import { StoreCode } from '@portal/schema/storeCode';
import type { CollectionProduct } from 'api/shopifyV2/types';
import {
  SHOPIFY_AG1_POUCH_SINGLE_SUB_VARIANT_ID,
  SHOPIFY_AG1_POUCH_SINGLE_SUB_VARIANT_ID_V53,
  SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID,
  SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID_V53,
  SHOPIFY_TRAVEL_PACK_SINGLE_SUB_VARIANT_ID,
  SHOPIFY_TRAVEL_PACK_SINGLE_SUB_VARIANT_ID_V53,
  SHOPIFY_TRAVEL_PACK_DOUBLE_SUB_VARIANT_ID,
  SHOPIFY_TRAVEL_PACK_DOUBLE_SUB_VARIANT_ID_V53
} from '@portal/config/base';
import { includesVariant } from 'shared/utils/subscriptionV2Helpers';

export const isSub = (metafields: { key: string; value: string }[]) => {
  if (!Array.isArray(metafields)) return false;
  return metafields.some((field) => field && field.key === 'sub' && field.value === 'true');
};

export const isOTP = (product: CollectionProduct) => {
  if (product.tags.includes('Core Products')) return false;
  if (isSub(product.metafields)) return false;
  return true;
};

export const isSinglePouchSubVariant = (variantId: string, store: StoreCode) => {
  return (
    includesVariant(variantId, SHOPIFY_AG1_POUCH_SINGLE_SUB_VARIANT_ID[store]) ||
    includesVariant(variantId, SHOPIFY_AG1_POUCH_SINGLE_SUB_VARIANT_ID_V53[store])
  );
};

export const isDoublePouchSubVariant = (variantId: string, store: StoreCode) => {
  return (
    includesVariant(variantId, SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID[store]) ||
    includesVariant(variantId, SHOPIFY_AG1_POUCH_DOUBLE_SUB_VARIANT_ID_V53[store])
  );
};

export const isSinglePacksSubVariant = (variantId: string, store: StoreCode) => {
  return (
    includesVariant(variantId, SHOPIFY_TRAVEL_PACK_SINGLE_SUB_VARIANT_ID[store]) ||
    includesVariant(variantId, SHOPIFY_TRAVEL_PACK_SINGLE_SUB_VARIANT_ID_V53[store])
  );
};

export const isDoublePacksSubVariant = (variantId: string, store: StoreCode) => {
  return (
    includesVariant(variantId, SHOPIFY_TRAVEL_PACK_DOUBLE_SUB_VARIANT_ID[store]) ||
    includesVariant(variantId, SHOPIFY_TRAVEL_PACK_DOUBLE_SUB_VARIANT_ID_V53[store])
  );
};
